import { getAuthHeaders } from './auth.js';
import API_BASE from '../api.js';

export const loadRazorpay = () => new Promise(resolve => {
  if (window.Razorpay) return resolve(true);
  const s = document.createElement('script');
  s.src = 'https://checkout.razorpay.com/v1/checkout.js';
  s.onload  = () => resolve(true);
  s.onerror = () => resolve(false);
  document.body.appendChild(s);
});

export const payForDiagnosis = async (assessmentId, { onSuccess, onCancel, onError }) => {
  const loaded = await loadRazorpay();
  if (!loaded) { onError?.('Could not load payment gateway.'); return; }

  const res = await fetch(`${API_BASE}/api/payment/create-order`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ planId: 'diagnosis_single', assessmentId }),
  });
  if (!res.ok) { const e = await res.json(); onError?.(e.error || 'Could not create order.'); return; }

  const { orderId, amount, currency } = await res.json();
  new window.Razorpay({
    key:         process.env.REACT_APP_RAZORPAY_KEY_ID,
    amount, currency,
    name:        'AssessMonk',
    description: 'AI Diagnosis — ₹19',
    order_id:    orderId,
    handler: async (response) => {
      try {
        const vRes = await fetch(`${API_BASE}/api/payment/verify`, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify({ ...response }),
        });
        if (!vRes.ok) {
          const e = await vRes.json();
          onError?.(e.error || 'Verification failed. Contact support if amount was deducted.');
        } else {
          onSuccess?.();
        }
      } catch {
        onError?.('Verification error. Contact support if amount was deducted.');
      }
    },
    theme: { color: '#4f46e5' },
    modal: { ondismiss: () => onCancel?.() },
  }).open();
};
